<template>
  <section class="cart" @click="$emit('openAndClose')">

    <div class="cart__block" @click.stop>

      <div class="cart__block-desc">

        <p class="cart__block-desc-title">Cart • {{ cart?.length }}</p>
        <p class="cart__block-total">
          Total: <span>{{ totalPrice }}$</span>
        </p>
        <button class="cart__block-desc-btn" @click="$emit('openAndClose', false)">
          <CloseIcon />
        </button>

      </div>

      <p class="cart__block-noProducts" v-show="!cart?.length">no products</p>

      <ul class="cart__block-list" v-show="cart?.length">
        <li class="cart__block-item" v-for="(product, index) in cart" :key="index">
          <img src="@/assets/images/icons/clock.svg" alt="" v-show="expected" class="cart__block-expected">
          <img :src="product?.thumbnail" alt="" class="cart__block-item-img" />
          <div class="cart__block-item-desc">
            <p class="cart__block-item-name">{{ product?.title }}</p>

            <div class="cart__block-item-price">${{ product?.price }}</div>
          </div>

          <button class="cart__block-add" @click="$store.commit('setCart', product?.id)">1+</button>
          
          <button class="cart__block-delete" @click="$store.commit('setCartDel', cart[index].id)">
            Delete
          </button>

        </li>
      </ul>

      <div class="cart__block-btns">
        <button class="cart__block-btn cancel__btn" v-show="expected" @click="expected = false">Cancel expected
          products</button>

        <button class="cart__block-btn buy__btn" @click="cart?.length ? expected = true : expected"
          :class="{ 'active': cart?.length >= 0 && !expected }">Buy</button>
      </div>
    </div>


  </section>
</template>
<script>
import { mapState } from "vuex";

import Cart from "@/components/modalCart/Cart";
import CloseIcon from "@/assets/images/icons/CloseIcon.vue";

export default {
  name: "Cart",
  components: {
    Cart,
    CloseIcon
  },
  data() {
    return {
      expected: false,
    }
  },
  computed: {
    ...mapState(["cart"]),
    totalPrice() {
      return this.cart.reduce(
        (acc, val) => acc + val.price,
        0
      );
    },
  },
};
</script>
